import Feedback from '@/components/feedback';
import Form from '@/components/form';
import Header from '@/components/header';
import Sidebar from '@/components/sidebar';
import Slider from '@/components/slider';
import Tab from '@/components/tab';
import Video from '@/components/video';

export default () => {
    Feedback.init();
    Form.init();
    Header.init();
    Sidebar.init();
    Slider.init();
    Tab.init();
    Video.init();
};

window.Feedback = Feedback;
